<script setup lang="ts">
  import { RouterView } from 'vue-router'
  import { useAppStore } from '@/stores/app'
  import { useAuthStore } from '@/stores/auth'
  import { useSyncStore } from '@/stores/sync'
  import { watchEffect, onMounted, ref } from 'vue'

  const appStore = useAppStore()
  const authStore = useAuthStore()
  const syncStore = useSyncStore()
  const ready = ref(false)

  // Sync dark mode class with document
  watchEffect(() => {
    const isDark =
      appStore.theme === 'dark' ||
      (appStore.theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches)
    document.documentElement.classList.toggle('dark', isDark)
  })

  // Init auth + sync on startup
  onMounted(async () => {
    appStore.init()
    await authStore.init()
    if (authStore.isAuthenticated) {
      syncStore.loadSyncStatus()
    }
    ready.value = true
  })
</script>

<template>
  <div
    v-if="!ready"
    class="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-slate-50 dark:bg-slate-950"
  >
    <div class="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_25%_20%,rgba(14,165,233,0.2),transparent_45%),radial-gradient(circle_at_70%_80%,rgba(16,185,129,0.18),transparent_45%)]" />
    <div class="relative z-10 flex items-center gap-3 rounded-2xl border border-white/60 dark:border-slate-700/70 bg-white/70 dark:bg-slate-900/70 px-6 py-4 backdrop-blur-xl shadow-xl shadow-slate-300/20 dark:shadow-black/30">
      <div class="w-8 h-8 border-[3px] border-sky-500 border-t-transparent rounded-full animate-spin" />
      <span class="text-sm font-semibold text-slate-700 dark:text-slate-200">جاري تحميل النظام...</span>
    </div>
  </div>
  <RouterView v-else />
</template>
